export default function getTriggerDistributionQueueData(firebase) {
	const db = firebase.firestore();
	return {
		ref: db.collection("tasks").doc("distributionQueue"),
		checkQueue: true,
		timestamp: firebase.firestore.FieldValue.serverTimestamp(),
	};
}
